import * as i0 from '@angular/core';
import { Injectable, Component, Input, Inject, NgModule } from '@angular/core';
import * as i1 from '@ngrx/store';
import { createAction, props, createFeatureSelector, createSelector, select, createReducer, on, StoreModule } from '@ngrx/store';
import { filter, map, switchMap, catchError } from 'rxjs/operators';
import { get } from 'lodash';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2$1 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import * as i1$1 from '@angular/common/http';
import { of } from 'rxjs';
import { COMMON_APP_CONFIG } from '@rogers/self-serve-common';
const _c0 = [[["", "brtSwitchOn", ""]], [["", "brtSwitchOff", ""]], [["", "brtSwitchOff", ""]]];
const _c1 = ["[brtSwitchOn]", "[brtSwitchOff]", "[brtSwitchOff]"];
function IsBrtSwitchOnComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function IsBrtSwitchOnComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function IsBrtSwitchOnComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
var BrtSwitchActionTypes = /*#__PURE__*/function (BrtSwitchActionTypes) {
  BrtSwitchActionTypes["LoadBrtSwitch"] = "[Global] Get BRT Switch from contentful";
  BrtSwitchActionTypes["LoadBrtSwitchSuccess"] = "[Global] Get BRT Switch Success from contentful";
  BrtSwitchActionTypes["LoadBrtSwitchFail"] = "[Global] Get BRT Switch Fail from contentful";
  BrtSwitchActionTypes["ClearBrtSwitch"] = "[Global] Clear BRT Switch from contentful";
  return BrtSwitchActionTypes;
}(BrtSwitchActionTypes || {});
const loadBrtSwitch = createAction(BrtSwitchActionTypes.LoadBrtSwitch);
const loadBrtSwitchSuccess = createAction(BrtSwitchActionTypes.LoadBrtSwitchSuccess, props());
const loadBrtSwitchFail = createAction(BrtSwitchActionTypes.LoadBrtSwitchFail, props());
const clearBrtSwitch = createAction(BrtSwitchActionTypes.ClearBrtSwitch);
const getBrtSwitchState = createFeatureSelector('brtSwitch');
const getBrtSwitch = createSelector(getBrtSwitchState, brtSwitch => {
  return get(brtSwitch, 'brtSwitches', []);
});
let BrtSwitchFacadeService = /*#__PURE__*/(() => {
  class BrtSwitchFacadeService {
    constructor(store) {
      this.store = store;
    }
    isBrtSwitchOn$(brtSwitchId) {
      return this.store.pipe(select(getBrtSwitch), filter(brtSwitches => !!brtSwitches), map(brtSwitches => {
        const value = brtSwitches.find(brtSwitch => brtSwitch.id === brtSwitchId);
        return !!value && value.switchIsOn;
      }));
    }
    resetBrtSwitch() {
      return this.store.dispatch(clearBrtSwitch());
    }
    getBrtSwitch() {
      return this.store.dispatch(loadBrtSwitch());
    }
    static {
      this.ɵfac = function BrtSwitchFacadeService_Factory(t) {
        return new (t || BrtSwitchFacadeService)(i0.ɵɵinject(i1.Store));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BrtSwitchFacadeService,
        factory: BrtSwitchFacadeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BrtSwitchFacadeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IsBrtSwitchOnComponent = /*#__PURE__*/(() => {
  class IsBrtSwitchOnComponent {
    constructor(brtSwitchFacadeService) {
      this.brtSwitchFacadeService = brtSwitchFacadeService;
    }
    ngOnInit() {
      this.isBrtSwitchOn$ = this.brtSwitchFacadeService.isBrtSwitchOn$(this.switchID);
    }
    static {
      this.ɵfac = function IsBrtSwitchOnComponent_Factory(t) {
        return new (t || IsBrtSwitchOnComponent)(i0.ɵɵdirectiveInject(BrtSwitchFacadeService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IsBrtSwitchOnComponent,
        selectors: [["ss-is-brt-switch-on"]],
        inputs: {
          switchID: "switchID"
        },
        ngContentSelectors: _c1,
        decls: 5,
        vars: 3,
        consts: [["brtSwitchOff", ""]],
        template: function IsBrtSwitchOnComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵtemplate(0, IsBrtSwitchOnComponent_Conditional_0_Template, 1, 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, IsBrtSwitchOnComponent_Conditional_2_Template, 1, 0)(3, IsBrtSwitchOnComponent_ng_template_3_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(0, i0.ɵɵpipeBind1(1, 1, ctx.isBrtSwitchOn$) ? 0 : 2);
          }
        },
        dependencies: [i2.AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return IsBrtSwitchOnComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrtSwitchEffects = /*#__PURE__*/(() => {
  class BrtSwitchEffects {
    constructor(http, actions$, appConfig) {
      this.http = http;
      this.actions$ = actions$;
      this.appConfig = appConfig;
      this.loadBrtSwitch$ = createEffect(() => this.actions$.pipe(ofType(BrtSwitchActionTypes.LoadBrtSwitch), switchMap(() => {
        return this.getBrtSwitch().pipe(map(brtSwitchResponse => {
          const brtSwitches = get(brtSwitchResponse, 'content', []);
          return loadBrtSwitchSuccess({
            brtSwitches
          });
        }), catchError(error => {
          const errorPayload = this.appConfig.getErrorTrackingObject(error);
          return of(loadBrtSwitchFail({
            error: errorPayload
          }));
        }));
      })));
    }
    getBrtSwitch() {
      return this.http.get(`${this.appConfig.contentBaseUrl}switches`, {
        headers: this.appConfig.getHeaders(),
        withCredentials: false
      });
    }
    static {
      this.ɵfac = function BrtSwitchEffects_Factory(t) {
        return new (t || BrtSwitchEffects)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2$1.Actions), i0.ɵɵinject(COMMON_APP_CONFIG));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BrtSwitchEffects,
        factory: BrtSwitchEffects.ɵfac
      });
    }
  }
  return BrtSwitchEffects;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const brtSwitchStateName = 'brtSwitch';
const initialState = {
  brtSwitches: [],
  loading: false,
  loaded: false,
  error: null
};
// tslint:disable-next-line:only-arrow-functions
const createBrtSwitchReducer = createReducer(initialState, on(loadBrtSwitch, state => ({
  ...state,
  loading: true
})), on(loadBrtSwitchSuccess, (state, {
  brtSwitches
}) => ({
  ...state,
  brtSwitches,
  loading: false,
  loaded: true,
  error: null
})), on(loadBrtSwitchFail, (state, {
  error
}) => ({
  ...state,
  error,
  brtSwitches: [],
  loading: false
})), on(clearBrtSwitch, _state => initialState));
// tslint:disable-next-line:only-arrow-functions
function brtSwitchReducer(state, action) {
  return createBrtSwitchReducer(state, action);
}
let BrtSwitchStoreModule = /*#__PURE__*/(() => {
  class BrtSwitchStoreModule {
    static {
      this.ɵfac = function BrtSwitchStoreModule_Factory(t) {
        return new (t || BrtSwitchStoreModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BrtSwitchStoreModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, StoreModule.forFeature(brtSwitchStateName, brtSwitchReducer), EffectsModule.forFeature([BrtSwitchEffects])]
      });
    }
  }
  return BrtSwitchStoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BrtSwitchActionTypes, BrtSwitchEffects, BrtSwitchFacadeService, BrtSwitchStoreModule, IsBrtSwitchOnComponent, brtSwitchReducer, brtSwitchStateName, clearBrtSwitch, createBrtSwitchReducer, getBrtSwitch, getBrtSwitchState, initialState, loadBrtSwitch, loadBrtSwitchFail, loadBrtSwitchSuccess };
